import { Box } from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { formatBlogDate, urlUpdate } from "../../../support/functions";
import { wpStyles } from "../../../theme/wp-styles";

const ArchiveCard = ({ title, date, categories, featuredImage, link }) => {
  const postDate = new Date(date);

  const category = categories ? categories.nodes[0].name : false;

  let imgUrl = featuredImage?.node.sourceUrl;

  if (imgUrl && imgUrl.includes("https://premierhsllc.local")) {
    imgUrl = imgUrl.replace(
      "https://premierhsllc.local",
      "http://premierhsllc.local"
    );
  }
  return (
    <Link href={urlUpdate(link)} passHref legacyBehavior>
      <Box
        as="a"
        display="block"
        textDecor="none"
        role="group"
        transition="color 0.3s ease"
      >
        {featuredImage && (
          <Box position="relative" maxH="205px" overflow="hidden">
            <Image
              src={imgUrl}
              alt={featuredImage.node.altText}
              // fill="true"
              width={featuredImage.node.mediaDetails.width}
              height={featuredImage.node.mediaDetails.height}
              style={{ objectFit: "cover" }}
            />
          </Box>
        )}
        {category && (
          <Box
            fontSize={wpStyles.fontSize.sm}
            textTransform="uppercase"
            fontWeight="bold"
            color="green.500"
            my={3}
          >
            {category}
          </Box>
        )}
        <Box
          fontSize={wpStyles.fontSize.md}
          fontWeight="bold"
          lineHeight="1.0"
          position="relative"
        >
          {title}
        </Box>
        <Box fontSize={wpStyles.fontSize.sm} mb={2} color="#999EA8" mt={2}>
          {formatBlogDate(postDate)}
        </Box>
      </Box>
    </Link>
  );
};

export default ArchiveCard;
